import {
  useScroll,
  useMotionValue,
  useMotionValueEvent,
  useIsPresent,
} from 'motion/react';
import { useRef } from 'react';

// Module-level shared state — optional manual/dev override (the "P" key).
// Per-page freezing during transitions is handled by useIsPresent below.
const isPausedRef = { current: false };

export function pauseScrollAnimations(paused) {
  isPausedRef.current = paused;
  // console.log('Scroll animations', paused ? 'paused' : 'resumed');
}

export function isScrollPaused() {
  return isPausedRef.current;
}

export function useCustomScroll(options = {}) {
  const { enabled = true, ...scrollOptions } = options;

  // false while this subtree is being removed by AnimatePresence (the exiting page)
  const isPresent = useIsPresent();
  const presentRef = useRef(isPresent);
  presentRef.current = isPresent;

  const { scrollYProgress } = useScroll(scrollOptions);
  const frozen = useMotionValue(scrollYProgress.get());

  useMotionValueEvent(scrollYProgress, 'change', (latest) => {
    // skip all work when disabled — frozen stays put so downstream transforms never recompute
    if (!enabled) return;
    // live only when this subtree is present and not manually paused
    if (presentRef.current && !isPausedRef.current) frozen.set(latest);
  });

  return { scrollYProgress: frozen };
}
